import { apiUrl, environment } from '@/constants/environment';

export const isDevelopment = environment === 'development';
export const isProduction = environment === 'production';

export const getApiUrl = (relUrL: string | undefined = undefined): string => {
  if (relUrL) {
    return `${apiUrl}/${relUrL}`;
  }
  return apiUrl;
};

export const capitalizeFirstLetter = (str: string): string =>
  str.charAt(0).toUpperCase() + str.slice(1);

export const getImageUrl = (id: string): string => getApiUrl(`images/${id}/`);
